// Copyright (c) 2026 WiseTime. All rights reserved.

import { lazy } from "react"
import { ROUTE_PATH, type RouteDefinition } from "./paths"

export const ROUTES: RouteDefinition[] = [
  {
    path: ROUTE_PATH.TIMELINE.path,
    title: ROUTE_PATH.TIMELINE.title,
    main: lazy(() => import("features/timeline/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
  {
    path: ROUTE_PATH.TRASH.path,
    title: ROUTE_PATH.TRASH.title,
    main: lazy(() => import("features/timeline/trash/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
  {
    path: ROUTE_PATH.NARRATE_PREFERENCES.path,
    title: ROUTE_PATH.NARRATE_PREFERENCES.title,
    main: lazy(() => import("features/narrate-preferences/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
  {
    path: ROUTE_PATH.TIMESHEET_FIELDS.path,
    title: ROUTE_PATH.TIMESHEET_FIELDS.title,
    main: lazy(() => import("features/timesheet-fields/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
  {
    path: ROUTE_PATH.FLAGS.path,
    title: ROUTE_PATH.FLAGS.title,
    main: lazy(() => import("features/flags/")),
    sidebar: lazy(() => import("features/shared/WtSidebar")),
  },
]
